import FeedbackPage from "@components/FeedbackPage"

export default function ValueProp() {
  return (
    <FeedbackPage
      emoji="🎯"
      titleKey="pages.onboarding.valueProp.heading"
      textKey="pages.onboarding.valueProp.info"
      points={[
        "pages.onboarding.valueProp.point1",
        "pages.onboarding.valueProp.point2",
        "pages.onboarding.valueProp.point3",
        "pages.onboarding.valueProp.point4",
      ]}
      buttonKey="pages.onboarding.valueProp.button"
    />
  )
}
